import React from 'react';
import axios from 'axios';
import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import ActivateAccountView from '../Views/TO/Activate/ActivateAccountView';

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();


class ActivateAccount extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            email: "",
            successEmail: "",
            pageLoading: true,
            activationLoading: false,
            activationSuccess: false,
            activationFailure: false,
            redirectURI: "/"
        }
    }

    // The first thing this component must do is call the activate service, 
    // and wait for its response we can change the activation state
    async componentDidMount() {
        // Get the code value and branch based on whether or not it is present
        let code = this.parseCodeFromURL()
        if (code) {
            await new Promise(r => setTimeout(r, 5000));
            this.setState({
                activationLoading: true
            })
            await new Promise(r => setTimeout(r, 5000));
            await this.activateAccount(code)
        }
        else {
            this.setState({ pageLoading: false })
            window.location.href = "/register";
        }
    }

    render() {
        return(
            <ActivateAccountView
            activationLoading = {this.state.activationLoading}
            pageLoading = {this.state.pageLoading}
            activationSuccess = {this.state.activationSuccess}
            activationFailure = {this.state.activationFailure}
            redirectURI = {this.state.redirectURI}
            />

        )
    }

    async activateAccount(code) {
        /*await axios({
            method: 'patch',
            url: appVars.getDCS3BaseURL() + '/v2/admin/account/activation',
            // url: '/v2/admin/account/activation',
            headers: {
                'X-API-KEY': await appVars.getAPIKey(),
                'X-BRAND': 'T',
                'X-CLIENT': 'SI-REG',
                'X-VERSION': '1.6',
                'Content-Type': 'application/json',
            },
            data: {
              'activationCode': code  
            }
        })
        .then((resp) => this.handleActivateAccountResponse(resp))
        .catch((err) => this.handleActivateAccountError(err))
        */

        const headers = {
            "x-brand" : 'T',
            "x-client" : "FR-Portal-Toyota"
            //"x-client" : "SI-REG"
        }

        const body = {
            'activationCode': code
        }

        await axios({
            headers,
            method: 'patch',
            data: body,
            url: appVars.getAPIGatewayURL() + "/activation",

        }).then((resp) => this.handleActivateAccountResponse(resp))
        .catch((err) => this.handleActivateAccountError(err))
    }

    handleActivateAccountResponse(resp) {
        let res = resp.data
        // var redirectURI = res['status']['redirectURI']
        var redirectURI = res['redirectURI']
        if (redirectURI !== null){
           this.setState({redirectURI : redirectURI})
       }
       // else{
            //this.setState({redirectURI : '/'})
           // this.setState({redirectURI : appVars.getAppHomeURL('DG')})
       // }
        if (res['status']['messages'][0]) {
            logger.log('stage', res['status']['messages'][0])
            if (res['status']['messages'][0]['code'] == 'M00000') {
                this.setState({
                    pageLoading: false,
                    activationLoading: false,
                    activationSuccess: true,
                    activationFailure: false
                })
            }
        }
    }

    handleActivateAccountError(err) {
        logger.log('stage', err)
        this.setState({
            pageLoading: false,
            activationLoading: false,
            activationSuccess: false,
            activationFailure: true
        })
    }

    parseCodeFromURL() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let code = params.get('code');
        return encodeURIComponent(code)
    }
}

export default ActivateAccount